import { useState } from "react"
import { useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"

export function useAuthForm({ schema, defaultValues, onSubmit }) {
  const [serverError, setServerError] = useState(null)
  const [serverErrorCode, setServerErrorCode] = useState(null)
  const form = useForm({ resolver: zodResolver(schema), defaultValues })

  const submit = form.handleSubmit(async (values, event) => {
    setServerError(null)
    setServerErrorCode(null)
    try {
      await onSubmit(values, event)
    } catch (err) {
      setServerError(err.message || "Something went wrong")
      setServerErrorCode(err.payload?.code ?? null)
    }
  })

  const clearServerError = () => {
    setServerError(null)
    setServerErrorCode(null)
  }

  return { form, serverError, serverErrorCode, clearServerError, submit }
}
